import React, { useState, useEffect, useRef, useMemo } from 'react';
// Replaced react-icons with inline SVG components
const CloseIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);
const UploadIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  </svg>
);
const FileIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
  </svg>
);
const TrashIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);
const PlusIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);
const ExclamationIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);
// New maximize and minimize icons
const MaximizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
  </svg>
);
const MinimizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
  </svg>
);
const API_URL = '/api';
const initialFields = {
  customer_code: '',
  customer_name: '',
  customer_type: '', // Added customer_type field
  country: '',
  BranchCode:'',
  department_id: '', // Added department_id field
  gst_number: '',
  pan_number: '',
  status: 'Active',
  contact_person_name: '',
  email: '',
  phone_number: '',
  account_name: '',
  account_number: '',
  ifsc_code: '',
  bank_name: '',
  bank_branch: '',
  logo: null,
  gst_certificate: null,
  company_reg_certificate: null,
  nda_contract_file: null
};
// Initial empty address structure
const emptyAddress = {
  address_id: '',
  address_code: '', // Now user can enter their own address code
  address_line1: '',
  city: '',
  state: '',
  zip_code: '',
  country: '',
  gst_number: '',
  pan_number: '',
  contact_person_name: '',
  contact_person_number: ''
};
// Initial empty contact structure
const emptyContact = {
  contact_id: '',
  contact_code: '',
  first_name: '',
  last_name: '',
  email: '',
  phone_number: ''
};


const SearchableDropdown = ({ 
  options, 
  value, 
  onChange, 
  placeholder = "Select",
  error = false,
  width = "w-full",
  getOptionLabel = (option) => option.name || option.label || option.toString(),
  getOptionValue = (option) => option.value || option.id || option.toString(),
  getOptionSecondaryLabel = (option) => option.code || option.id || "",
  disabled = false,
  className = "",
  onMultiSelectTrigger = null,
  multiSelectShortcut = null
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const dropdownListRef = useRef(null);
  const searchInputRef = useRef(null);

  // Update dropdown position when opened
  useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom,
        left: rect.left,
        width: rect.width
      });
    }
  }, [isOpen]);

  // Handle window resize and scroll to update position
  useEffect(() => {
    if (!isOpen) return;
    
    const handleUpdatePosition = () => {
      if (triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        setPosition({
          top: rect.bottom,
          left: rect.left,
          width: rect.width
        });
      }
    };
    
    window.addEventListener('resize', handleUpdatePosition);
    window.addEventListener('scroll', handleUpdatePosition);
    
    return () => {
      window.removeEventListener('resize', handleUpdatePosition);
      window.removeEventListener('scroll', handleUpdatePosition);
    };
  }, [isOpen]);

  // Scroll highlighted item into view
  useEffect(() => {
    if (isOpen && dropdownListRef.current && highlightedIndex >= 0) {
      const items = dropdownListRef.current.querySelectorAll('.dropdown-item');
      if (items[highlightedIndex]) {
        items[highlightedIndex].scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    }
  }, [highlightedIndex, isOpen]);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      // Clear search term and reset highlighted index when opening
      setSearchTerm('');
      setHighlightedIndex(-1);
      
      // Focus the search input after a short delay to ensure it's rendered
      setTimeout(() => {
        searchInputRef.current.focus();
      }, 0);
    }
  }, [isOpen]);

  // Filter options based on search term
  const filteredOptions = useMemo(() => {
    if (!searchTerm) return options;
    const term = searchTerm.toLowerCase();
    
    return options.filter(option => {
      const label = getOptionLabel(option).toLowerCase();
      const secondaryLabel = getOptionSecondaryLabel(option).toLowerCase();
      
      return label.includes(term) || secondaryLabel.includes(term);
    });
  }, [options, searchTerm, getOptionLabel, getOptionSecondaryLabel]);

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    // Check for multi-select shortcut
    if (onMultiSelectTrigger && multiSelectShortcut && e.ctrlKey && e.key === multiSelectShortcut) {
      e.preventDefault();
      onMultiSelectTrigger();
      return;
    }

    if (!isOpen) {
      if (e.key === 'ArrowDown' || e.key === 'Enter') {
        setIsOpen(true);
        return;
      }
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setHighlightedIndex(prev => {
          if (prev < filteredOptions.length - 1) {
            return prev + 1;
          } else if (filteredOptions.length > 0) {
            return 0; // Loop back to first item
          }
          return prev;
        });
        break;
      case 'ArrowUp':
        e.preventDefault();
        setHighlightedIndex(prev => {
          if (prev > 0) {
            return prev - 1;
          } else if (filteredOptions.length > 0) {
            return filteredOptions.length - 1; // Loop to last item
          }
          return prev;
        });
        break;
      case 'Enter':
        e.preventDefault();
        if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
          handleSelectOption(filteredOptions[highlightedIndex]);
        }
        break;
      case 'Escape':
        setIsOpen(false);
        break;
      default:
        break;
    }
  };

  const handleSelectOption = (option) => {
    onChange(getOptionValue(option));
    setIsOpen(false);
    setSearchTerm('');
    setHighlightedIndex(-1);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get selected option
  const selectedOption = options.find(option => getOptionValue(option) === value);

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <div
        className={`${width} border rounded-lg px-3 py-2 cursor-pointer flex justify-between items-center ${
          error ? 'border-red-400' : 'border-[#E2E8F0]'
        } ${isOpen ? 'ring-1 ring-[#BDDDFC]' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        ref={triggerRef}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <span className="truncate">
          {selectedOption ? getOptionLabel(selectedOption) : placeholder}
        </span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      
      {isOpen && (
        <div 
          className="fixed z-[9999] bg-white border border-[#E2E8F0] rounded-lg shadow-lg"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            width: `${position.width}px`,
          }}
        >
          <div className="p-2 border-b border-[#E2E8F0]">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search..."
              className="w-full px-2 py-1 border border-[#E2E8F0] rounded focus:outline-none focus:ring-1 focus:ring-[#BDDDFC]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
          
          <div 
            className="max-h-60 overflow-y-auto" 
            ref={dropdownListRef}
          >
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={getOptionValue(option)}
                  className={`dropdown-item px-3 py-2 cursor-pointer hover:bg-[#F1F5F9] ${
                    highlightedIndex === index ? 'bg-[#BDDDFC]' : ''
                  } ${value === getOptionValue(option) ? 'bg-[#E6F0FF]' : ''}`}
                  onClick={() => handleSelectOption(option)}
                  onMouseEnter={() => setHighlightedIndex(index)}
                >
                  <div className="font-medium">{getOptionLabel(option)}</div>
                  {getOptionSecondaryLabel(option) && (
                    <div className="text-xs text-gray-500">{getOptionSecondaryLabel(option)}</div>
                  )}
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-gray-500">No options found</div>
            )}
          </div>
        </div>
      )}
      
      {error && <span className="text-xs text-red-500">*</span>}
    </div>
  );
};

// ---------- Error Popup Component ----------

const ErrorPopup = ({ show, messages = [], onClose }) => {
  const tryAgainRef = React.useRef(null);

  // close on Escape for accessibility
  React.useEffect(() => {
    if (!show) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [show, onClose]);

  // focus primary button when shown
  React.useEffect(() => {
    if (show && tryAgainRef.current) tryAgainRef.current.focus();
  }, [show]);

  if (!show) return null;

  // Normalize incoming messages -> array of strings
  const normalized = (Array.isArray(messages) ? messages : [messages]).map((m) => {
    if (typeof m === 'string') return m;
    if (m instanceof Error) return m.message || String(m);
    if (m && typeof m === 'object') {
      // prefer `message` property, else stringify (safe)
      return m.message || JSON.stringify(m);
    }
    return String(m);
  });

  const copyErrors = async () => {
    const text = normalized.length ? normalized.join('\n') : 'No details';
    try {
      await navigator.clipboard.writeText(text);
      // eslint-disable-next-line no-alert
      alert('Errors copied to clipboard');
    } catch {
      // eslint-disable-next-line no-alert
      alert('Copy failed — please copy manually.');
    }
  };

  // Render all messages as pills. Use truncation for layout but show full text on hover via `title`.
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/45" onClick={onClose} />
      <div className="relative z-10 w-11/12 max-w-md bg-white rounded-2xl shadow-2xl p-6">
        <div className="flex items-center justify-center -mt-10 mb-3">
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center shadow-sm">
            <svg className="w-8 h-8 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>

        <div className="text-center mb-3">
          <h2 className="text-xl font-semibold text-red-600">Error</h2>
          <p className="text-sm text-gray-600 mt-1">
            {normalized.length > 0 ? `${normalized.length} problem${normalized.length > 1 ? 's' : ''} found` : 'Something went wrong'}
          </p>
        </div>

        {/* All messages as pills — wrap and scroll if too many */}
        <div className="max-h-40 overflow-y-auto mb-3">
          <div className="flex flex-wrap gap-2">
            {normalized.map((m, i) => (
              <span
                key={`pill-${i}`}
                title={m}
                className="text-xs px-3 py-1 bg-red-50 border border-red-200 text-red-800 rounded-full shadow-sm max-w-full truncate"
                style={{ display: 'inline-block', maxWidth: '100%' }}
              >
                {m}
              </span>
            ))}
          </div>
        </div>

        <div className="flex justify-center items-center gap-3">
          
          <button ref={tryAgainRef} onClick={onClose} className="px-5 py-2 bg-red-600 text-white rounded-full shadow hover:bg-red-700">Try Again</button>
        </div>
      </div>
    </div>
  );
};

// Helper function to check if a value is a File object
const isFile = (value) => value instanceof File;
const CustomerFormModal = ({ open, onClose, onSubmit, initialData, isEdit, loading }) => {
  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});
  const [isLoadingCode, setIsLoadingCode] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [filePreviews, setFilePreviews] = useState({});
  const [formLoading, setFormLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
    // Error popup state (add this)
  const [errorPopup, setErrorPopup] = useState({ show: false, messages: [] });

  const [activeTab, setActiveTab] = useState('customerInfo');
  const [currentStep, setCurrentStep] = useState(0);
  const [isUserValid, setIsUserValid] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [submissionAttempted, setSubmissionAttempted] = useState(false);
  const [customerTypes, setCustomerTypes] = useState([]); // Added state for customer types
  
  // New state for maximize/minimize functionality
  const [isMaximized, setIsMaximized] = useState(false);
  const [previousSize, setPreviousSize] = useState({ width: 'max-w-6xl', height: 'h-full' });
  
  // Address states
  const [billingAddresses, setBillingAddresses] = useState([emptyAddress]);
  const [shippingAddresses, setShippingAddresses] = useState([emptyAddress]);
  
  // Contacts state
  const [contacts, setContacts] = useState([emptyContact]);
  
  // Add branches state
  const [branches, setBranches] = useState([]);
  const [loadingBranches, setLoadingBranches] = useState(false);
  
  // Department-related state
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [screenConfig, setScreenConfig] = useState(null);
  const [showDepartmentField, setShowDepartmentField] = useState(false);
  
  const logoInputRef = useRef(null);
  const gstInputRef = useRef(null);
  const companyRegInputRef = useRef(null);
  const ndaInputRef = useRef(null);
  
  const tabs = [
    { id: 'customerInfo', name: 'Customer Info' },
    { id: 'contactInfo', name: 'Contact Info' },
    { id: 'addressInfo', name: 'Address' },
    { id: 'bankInfo', name: 'Bank Info' },
    { id: 'documents', name: 'Documents' },
  ];
  
  // Calculate form completion percentage
  const completionPercentage = Math.round(((currentStep + 1) / tabs.length) * 100);
  
  // Function to fetch branches
  const fetchBranches = async () => {
    setLoadingBranches(true);
    try {
      const response = await fetch(`${API_URL}/branches`); // Replace with your actual branches API endpoint
      const data = await response.json();
      setBranches(data);
    } catch (error) {
      console.error('Error fetching branches:', error);
      // If API fails, set some default branches
    } finally {
      setLoadingBranches(false);
    }
  };
  
  // Function to fetch current user
  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('authToken'); // store token after login
      if (!token) {
        setIsUserValid(false);
        setAuthError('No token found. Please log in again.');
        return false;
      }
      const userRes = await fetch(`${API_URL}/current-user`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const userData = await userRes.json();
      
      if (userData.user && userData.user.UserID) {
        console.log('Setting current user:', userData.user);
        setCurrentUser(userData.user);
        setIsUserValid(true);
        setAuthError(null);
        return true;
      } else {
        console.error('Invalid user data received:', userData);
        setIsUserValid(false);
        setAuthError('User information not available. Please log in again.');
        return false;
      }
    } catch (error) {
      console.error('Error fetching current user:', error);
      setIsUserValid(false);
      setAuthError('Error fetching user information. Please refresh the page.');
      return false;
    }
  };
  
  // Function to fetch departments
  const fetchDepartments = async () => {
    setLoadingDepartments(true);
    try {
      const response = await fetch(`${API_URL}/departments`);
      const data = await response.json();
      console.log('Fetched departments:', data);
      setDepartments(data);
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartments([]);
    } finally {
      setLoadingDepartments(false);
    }
  };
  
  // Function to fetch screen configuration
  const fetchScreenConfig = async () => {
    try {
      const response = await fetch(`${API_URL}/screens`);
      const data = await response.json();
      console.log('Fetched screen configurations:', data);
      
      // Find the customer screen configuration
      const customerScreen = data.screens.find(screen => 
        screen.ScreenName.toLowerCase() === 'CustomerMaster'.toLowerCase()
      );
      
      console.log('Customer screen configuration:', customerScreen);
      if (customerScreen) {
        setScreenConfig(customerScreen);
        // Show department field if ShowOnHeader is 1
        const shouldShowDepartment = customerScreen.ShowOnHeader === true;
        setShowDepartmentField(shouldShowDepartment);
        
        // If department field should be shown, fetch departments
        if (shouldShowDepartment) {
          fetchDepartments();
        }
      }
    } catch (error) {
      console.error('Error fetching screen configuration:', error);
      setShowDepartmentField(false);
    }
  };
  
  // Function to fetch customer types
  const fetchCustomerTypes = async () => {
    try {
      console.log('Fetching customer types...');
      const typesRes = await fetch(`${API_URL}/customer-types`);
      const typesData = await typesRes.json();
      console.log('Customer types received:', typesData);
      
      // if (typesData.customerTypes) {
      //   setCustomerTypes(typesData.customerTypes);
      // } else {
        // If API doesn't return customer types, set default options
        setCustomerTypes([
          { customer_type: 'Corporate' },
          { customer_type: 'Individual' },
          { customer_type: 'Government' },
          { customer_type: 'Non-Profit' }
        ]);
      // }
    } catch (error) {
      console.error('Error fetching customer types:', error);
      // Set default customer types on error
      setCustomerTypes([
        { customer_type: 'Corporate' },
        { customer_type: 'Individual' },
        { customer_type: 'Government' },
        { customer_type: 'Non-Profit' }
      ]);
    }
  };
  
  // Toggle maximize/minimize
  const toggleMaximize = () => {
    if (isMaximized) {
      // Restore previous size
      setIsMaximized(false);
    } else {
      // Save current size and maximize
      setPreviousSize({ width: 'max-w-6xl', height: 'h-full' });
      setIsMaximized(true);
    }
  };
  
  useEffect(() => {
    fetchCurrentUser();
    fetchCustomerTypes();
    fetchBranches();
    fetchScreenConfig(); // Fetch screen configuration to determine if department field should be shown
  }, []);
  
  useEffect(() => {
    if (open) {
      // Fetch current user when modal opens
      fetchCurrentUser();
      fetchCustomerTypes();
      fetchBranches();
      fetchScreenConfig(); // Fetch screen configuration to determine if department field should be shown
      
      if (isEdit && initialData) {
        // Destructure to remove created_by and updated_by
        const { created_by, updated_by, ...dataWithoutUserFields } = initialData;
        const departmentId = initialData.DepartmentID || initialData.department_id || '';
      console.log('Setting department_id to:', departmentId);
        setFields({ ...initialFields, ...dataWithoutUserFields ,department_id: departmentId.toString()|| ''});
        setSelectedCustomer(initialData);
        
        // Set addresses if they exist
        if (initialData.billing_addresses && initialData.billing_addresses.length > 0) {
          setBillingAddresses(initialData.billing_addresses);
        } else {
          setBillingAddresses([emptyAddress]);
        }
        
        if (initialData.shipping_addresses && initialData.shipping_addresses.length > 0) {
          setShippingAddresses(initialData.shipping_addresses);
        } else {
          setShippingAddresses([emptyAddress]);
        }
        
        // Set contacts if they exist
        if (initialData.contacts && initialData.contacts.length > 0) {
          setContacts(initialData.contacts);
        } else {
          setContacts([emptyContact]);
        }
        
        const previews = {};
        if (initialData.logo) previews.logo = initialData.logo;
        if (initialData.gst_certificate) previews.gst_certificate = initialData.gst_certificate;
        if (initialData.company_reg_certificate) previews.company_reg_certificate = initialData.company_reg_certificate;
        if (initialData.nda_contract_file) previews.nda_contract_file = initialData.nda_contract_file;
        
        setFilePreviews(previews);
      } else {
        setFields(initialFields);
        setFilePreviews({});
        setSelectedCustomer(null);
        // Reset addresses for new customer
        setBillingAddresses([emptyAddress]);
        setShippingAddresses([emptyAddress]);
        // Reset contacts for new customer
        setContacts([emptyContact]);
        
        setIsLoadingCode(true);
        fetch(`${API_URL}/customerlatestcode`)
          .then(res => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
          })
          .then(data => {
            console.log('Received customer code:', data);
            if (data && data.nextCode) {
              setFields(prev => ({ ...prev, customer_code: data.nextCode }));
            } else {
              console.error('No nextCode in response:', data);
              setFields(prev => ({ ...prev, customer_code: 'CUST-01' }));
            }
          })
          .catch(error => {
            console.error('Error fetching next customer code:', error);
            setFields(prev => ({ ...prev, customer_code: 'CUST-01' }));
          })
          .finally(() => {
            setIsLoadingCode(false);
          });
      }
      setErrors({});
      setIsSubmitting(false);
      setCurrentStep(0);
      setActiveTab('customerInfo');
      setSubmissionAttempted(false);
      // Reset maximize state when modal opens
      setIsMaximized(false);
      setShowDepartmentField(false); // Reset department field state
      setScreenConfig(null); // Reset screen config
    }
  }, [open, initialData, isEdit]);
  
  const handleChange = e => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };
  
  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      setFields(prev => ({
        ...prev,
        [fieldName]: file
      }));
      setFilePreviews(prev => ({
        ...prev,
        [fieldName]: URL.createObjectURL(file)
      }));
    }
  };
  
  const handleFileRemove = (fieldName, inputRef) => {
    setFields(prev => ({
      ...prev,
      [fieldName]: null
    }));
    setFilePreviews(prev => {
      const newPreviews = { ...prev };
      delete newPreviews[fieldName];
      return newPreviews;
    });
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  
  const getFilePreviewIcon = (preview) => {
    if (!preview) return null;
    if (typeof preview === 'string' && (preview.match(/\.(jpeg|jpg|gif|png)$/) || preview.startsWith('data:image'))) {
      return <img src={preview} alt="file preview" className="w-10 h-10 object-contain" />;
    }
    return <FileIcon className="text-[#6A89A7] text-xl" />;
  };
  
  const validate = () => {
  const errs = {};

  // Validate required customer info
  if (!fields.customer_name) errs.customer_name = 'Customer name is required';
  if (!fields.country) errs.country = 'Country is required';
  if (!fields.status) errs.status = 'Status is required';
  if (!fields.BranchCode) errs.BranchCode = 'Branch is required';

  // Add department validation only if the field is shown
  if (showDepartmentField && !fields.department_id) errs.department_id = 'Department is required';

  // Validate contacts - at least one complete contact
  const hasValidContact = contacts.some(contact => contact.contact_code && contact.first_name);
  if (!hasValidContact) {
    errs.contacts = 'At least one complete contact with contact code and first name is required';
  }

  // Validate addresses - at least one complete billing and shipping address
  const hasValidBillingAddress = billingAddresses.some(addr => addr.address_code && addr.address_line1 && addr.city && addr.state && addr.zip_code && addr.country);
  const hasValidShippingAddress = shippingAddresses.some(addr => addr.address_code && addr.address_line1 && addr.city && addr.state && addr.zip_code && addr.country);

  // Check for duplicate address codes within the same address type
  const billingAddressCodes = billingAddresses.map(addr => addr.address_code).filter(Boolean);
  const shippingAddressCodes = shippingAddresses.map(addr => addr.address_code).filter(Boolean);

  const duplicateBillingCodes = billingAddressCodes.filter((code, index) => billingAddressCodes.indexOf(code) !== index);
  const duplicateShippingCodes = shippingAddressCodes.filter((code, index) => shippingAddressCodes.indexOf(code) !== index);

  if (duplicateBillingCodes.length > 0) {
    errs.billing_address_code = `Duplicate billing address codes: ${duplicateBillingCodes.join(', ')}`;
  }

  if (duplicateShippingCodes.length > 0) {
    errs.shipping_address_code = `Duplicate shipping address codes: ${duplicateShippingCodes.join(', ')}`;
  }

  if (!hasValidBillingAddress) {
    errs.billing_address = 'At least one complete billing address with address code is required';
  }

  if (!hasValidShippingAddress) {
    errs.shipping_address = 'At least one complete shipping address with address code is required';
  }

  setErrors(errs);

  const valid = Object.keys(errs).length === 0;
  if (!valid) {
    // compute error messages and show popup
    const allErrors = getAllErrorsFrom(errs, {}, {}, fields, billingAddresses, shippingAddresses, contacts);
    setErrorPopup({ show: true, messages: allErrors });
  }
  return valid;
};

// Create an errors array from provided error objects and current form state.
const getAllErrorsFrom = (errsObj = errors, billingErrs = {}, shippingErrs = {}, fieldsLocal = fields, billingLocal = billingAddresses, shippingLocal = shippingAddresses, contactsLocal = contacts) => {
  const allErrors = [];

  // header / field errors
  Object.entries(errsObj).forEach(([k, msg]) => {
    if (msg) allErrors.push(msg);
  });

  // billing address errors - we store top-level billing_address and billing_address_code in errsObj
  if (errsObj.billing_address) allErrors.push(errsObj.billing_address);
  if (errsObj.billing_address_code) allErrors.push(errsObj.billing_address_code);

  // shipping address errors
  if (errsObj.shipping_address) allErrors.push(errsObj.shipping_address);
  if (errsObj.shipping_address_code) allErrors.push(errsObj.shipping_address_code);

  // contact errors
  if (errsObj.contacts) allErrors.push(errsObj.contacts);

  // also list per-address messages if you decide to create them later (keeps function extensible)
  billingLocal.forEach((addr, idx) => {
    // add specific missing fields if you want - currently we added top-level billing errors in errsObj
  });

  shippingLocal.forEach((addr, idx) => {
    // same as above
  });

  return allErrors;
};

// wrapper to get current errors
const getAllErrors = () => getAllErrorsFrom();


  
  const goToNextStep = () => {
    if (currentStep < tabs.length - 1) {
      setCurrentStep(prev => prev + 1);
      setActiveTab(tabs[currentStep + 1].id);
    }
  };
  
  const goToPreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
      setActiveTab(tabs[currentStep - 1].id);
    }
  };
  
  const saveCurrentStep = async () => {
    setFormLoading(true);
    
    try {
      console.log(`Saving step ${currentStep + 1}: ${tabs[currentStep].name}`);
      
      // If this is the last step, validate and submit the entire form
      if (currentStep === tabs.length - 1) {
        setSubmissionAttempted(true);
        if (!validate()) {
          setFormLoading(false);
          return;
        }
        await handleSubmit();
      } else {
        // Move to next step
        goToNextStep();
      }
    } catch (error) {
      console.error('Error saving step:', error);
      alert('An error occurred while saving. Please try again.');
    } finally {
      setFormLoading(false);
    }
  };
  
  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        // Get the base64 string
        const base64 = reader.result.split(',')[1]; // Remove the data:image/png;base64, part
        resolve(base64);
      };
      reader.onerror = () => {
        reject(new Error('Failed to read file'));
      };
      reader.readAsDataURL(file);
    });
  };
  
  // Address handling functions
  const handleBillingAddressChange = (index, field, value) => {
    const updatedAddresses = [...billingAddresses];
    updatedAddresses[index] = { ...updatedAddresses[index], [field]: value  };
    setBillingAddresses(updatedAddresses);
    
    // Clear error when user starts typing
    if (errors.billing_address || errors.billing_address_code) {
      setErrors(prev => ({ 
        ...prev, 
        billing_address: null,
        billing_address_code: null
      }));
    }
  };
  
  const handleShippingAddressChange = (index, field, value) => {
    const updatedAddresses = [...shippingAddresses];
    updatedAddresses[index] = { ...updatedAddresses[index], [field]: value };
    setShippingAddresses(updatedAddresses);
    
    // Clear error when user starts typing
    if (errors.shipping_address || errors.shipping_address_code) {
      setErrors(prev => ({ 
        ...prev, 
        shipping_address: null,
        shipping_address_code: null
      }));
    }
  };
  
  const addBillingAddress = () => {
    setBillingAddresses([...billingAddresses, emptyAddress]);
  };
  
  const addShippingAddress = () => {
    setShippingAddresses([...shippingAddresses, emptyAddress]);
  };
  
  const removeBillingAddress = (index) => {
    if (billingAddresses.length > 1) {
      const updatedAddresses = [...billingAddresses];
      updatedAddresses.splice(index, 1);
      setBillingAddresses(updatedAddresses);
    }
  };
  
  const removeShippingAddress = (index) => {
    if (shippingAddresses.length > 1) {
      const updatedAddresses = [...shippingAddresses];
      updatedAddresses.splice(index, 1);
      setShippingAddresses(updatedAddresses);
    }
  };
  
  // Contact handling functions
  const handleContactChange = (index, field, value) => {
    const updatedContacts = [...contacts];
    updatedContacts[index] = { ...updatedContacts[index], [field]: value };
    setContacts(updatedContacts);
    
    // Clear error when user starts typing
    if (errors.contacts) {
      setErrors(prev => ({ ...prev, contacts: null }));
    }
  };
  
  const addContact = () => {
    setContacts([...contacts, emptyContact]);
  };
  
  const removeContact = (index) => {
    if (contacts.length > 1) {
      const updatedContacts = [...contacts];
      updatedContacts.splice(index, 1);
      setContacts(updatedContacts);
    }
  };
  
  const handleSubmit = async (e) => {
  if (e) e.preventDefault();

  // run client-side validation BEFORE doing any network call
  setSubmissionAttempted(true);
  const isValid = validate();
  if (!isValid) {
    // ensure loading flags are off and stop submission
    setFormLoading(false);
    setIsSubmitting(false);
    return;
  }

  // now we are sure client-side checks passed
  if (isSubmitting || formLoading) {
    console.log('Form submission already in progress, ignoring duplicate submission');
    return;
  }

  // proceed with submit
  setIsSubmitting(true);
  setFormLoading(true);

  // ... rest of your existing submit code ...

    
    console.log('Submitting form with fields:', fields);
    console.log('Contacts:', contacts);
    console.log('Billing addresses:', billingAddresses);
    console.log('Shipping addresses:', shippingAddresses);
    
    try {
      // Create a new FormData
      const formData = new FormData();
      
      // Add all text fields to FormData, excluding created_by and updated_by
      Object.keys(fields).forEach(key => {
        if (key !== 'logo' && 
            key !== 'gst_certificate' && 
            key !== 'company_reg_certificate' && 
            key !== 'nda_contract_file' &&
            key !== 'created_by' && 
            key !== 'updated_by') {
          // Ensure we're not appending arrays
          const value = Array.isArray(fields[key]) ? fields[key][0] || fields[key][1] || '' : fields[key] || '';
          formData.append(key, value);
        }
      });
      
      // Only append the relevant user ID field based on operation
      const userId = parseInt(currentUser.UserID);
      console.log('Using user ID:', userId);
      
      if (isEdit && selectedCustomer) {
        formData.append('updated_by', userId);
        console.log('Appended updated_by:', userId);
      } else {
        formData.append('created_by', userId);
        console.log('Appended created_by:', userId);
      }
      
      // Add contacts to FormData
      contacts.forEach((contact, index) => {
        Object.keys(contact).forEach(key => {
          if (key !== 'contact_id') { // Don't include contact_id for new contacts
            formData.append(`contact_${index}_${key}`, contact[key] || '');
          } else if (contact[key]) { // Only include contact_id if it exists (for editing)
            formData.append(`contact_${index}_${key}`, contact[key]);
          }
        });
      });
      
      // Add addresses to FormData
      billingAddresses.forEach((address, index) => {
        Object.keys(address).forEach(key => {
          if (key !== 'address_id') { // Don't include address_id for new addresses
            formData.append(`billing_address_${index}_${key}`, address[key] || '');
          } else if (address[key]) { // Only include address_id if it exists (for editing)
            formData.append(`billing_address_${index}_${key}`, address[key]);
          }
        });
      });
      
      shippingAddresses.forEach((address, index) => {
        Object.keys(address).forEach(key => {
          if (key !== 'address_id') { // Don't include address_id for new addresses
            formData.append(`shipping_address_${index}_${key}`, address[key] || '');
          } else if (address[key]) { // Only include address_id if it exists (for editing)
            formData.append(`shipping_address_${index}_${key}`, address[key]);
          }
        });
      });
      
      // Log FormData contents for debugging
      console.log('FormData contents:');
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}: ${pair[1]} (type: ${typeof pair[1]})`);
      }
      
      // Handle file fields separately - convert to base64
      if (fields.logo) {
        try {
          const logoBase64 = await readFileAsBase64(fields.logo);
          formData.append('logo', logoBase64);
        } catch (error) {
          console.error('Error reading logo file:', error);
        }
      }
      
      if (fields.gst_certificate) {
        try {
          const gstBase64 = await readFileAsBase64(fields.gst_certificate);
          formData.append('gst_certificate', gstBase64);
          formData.append('gst_file_name', fields.gst_certificate.name);
          formData.append('gst_doc_type', fields.gst_certificate.type);
        } catch (error) {
          console.error('Error reading GST certificate file:', error);
        }
      }
      
      if (fields.company_reg_certificate) {
        try {
          const regBase64 = await readFileAsBase64(fields.company_reg_certificate);
          formData.append('company_reg_certificate', regBase64);
          formData.append('company_reg_file_name', fields.company_reg_certificate.name);
          formData.append('company_reg_file_type', fields.company_reg_certificate.type);
        } catch (error) {
          console.error('Error reading company registration file:', error);
        }
      }
      
      if (fields.nda_contract_file) {
        try {
          const ndaBase64 = await readFileAsBase64(fields.nda_contract_file);
          formData.append('nda_contract_file', ndaBase64);
          formData.append('nda_contract_file_name', fields.nda_contract_file.name);
          formData.append('nda_contract_file_type', fields.nda_contract_file.type);
        } catch (error) {
          console.error('Error reading NDA contract file:', error);
        }
      }
      
      console.log('Submitting form data:', {
        isEdit,
        customerCode: isEdit ? selectedCustomer?.customer_code : null,
        hasLogo: !!fields.logo,
        hasGstCert: !!fields.gst_certificate,
        hasCompanyReg: !!fields.company_reg_certificate,
        hasNda: !!fields.nda_contract_file,
        contactsCount: contacts.length,
        billingAddressesCount: billingAddresses.length,
        shippingAddressesCount: shippingAddresses.length
      });
      
      let response;
      if (isEdit && selectedCustomer) {
        console.log('Updating customer:', selectedCustomer.customer_code);
        response = await fetch(`${API_URL}/customers/${selectedCustomer.customer_code}`, {
          method: 'PUT',
          body: formData,
        });
      } else {
        console.log('Creating new customer');
        response = await fetch(`${API_URL}/customers`, {
          method: 'POST',
          body: formData,
        });
      }
      
           if (!response.ok) {
        const errorData = await response.json();
        console.error('Server response:', {
          status: response.status,
          statusText: response.statusText,
          error: errorData
        });

        // ✅ Case 1: Duplicate customer code (your existing retry logic)
        if (response.status === 409 && errorData.error === 'DUPLICATE_CUSTOMER_CODE') {
          console.log('Duplicate customer code detected, refreshing code...');
          try {
            const codeResponse = await fetch(`${API_URL}/customerlatestcode`);
            if (codeResponse.ok) {
              const codeData = await codeResponse.json();
              if (codeData && codeData.nextCode) {
                setFields(prev => ({ ...prev, customer_code: codeData.nextCode }));
                // keep your retry logic block as it is here
                // (the part that recreates formData and resubmits)
              }
            }
          } catch (retryError) {
            console.error('Error during retry:', retryError);
            throw new Error('Failed to create customer after retry. Please try again.');
          }
        }

        // ✅ Case 2: Duplicate address code (show popup)
        if (response.status === 409 && errorData.error === 'DUPLICATE_ADDRESS_CODE') {
          setErrorPopup({
            show: true,
            messages: [errorData.message || 'An address code already exists. Please use a unique address code.']
          });
          return;
        }

        // ✅ Case 3: Duplicate contact code (show popup)
        if (response.status === 409 && errorData.error === 'DUPLICATE_CONTACT_CODE') {
          setErrorPopup({
            show: true,
            messages: [errorData.message || 'A contact code already exists. Please use a unique contact code.']
          });
          return;
        }

        // ✅ Case 4: Any other server-side error (show popup)
        const serverMsg = errorData && (errorData.message || errorData.error)
          ? (errorData.message || errorData.error)
          : `Failed to ${isEdit ? 'update' : 'create'} customer`;

        setErrorPopup({ show: true, messages: [serverMsg] });
        throw new Error(serverMsg);
      }

      const result = await response.json();
      console.log('Server response:', result);
      
      onSubmit(formData);
      onClose();
        } catch (error) {
      console.error('Error saving customer:', error);
      const msgs = [];
      if (error && error.message) msgs.push(error.message);
      if (msgs.length === 0) msgs.push('An error occurred while saving the customer');
      setErrorPopup({ show: true, messages: msgs });
    } finally {
      setFormLoading(false);
      setIsSubmitting(false);
    }

  };
  
  // Get error messages for the documents tab
  const getDocumentsTabErrors = () => {
    if (!submissionAttempted) return [];
    
    const tabErrors = [];
    
    // Only show errors for required fields
    if (errors.customer_name) tabErrors.push(errors.customer_name);
    if (errors.country) tabErrors.push(errors.country);
    if (errors.status) tabErrors.push(errors.status);
    if (errors.department_id) tabErrors.push(errors.department_id); // Add department error if shown
    if (errors.contacts) tabErrors.push(errors.contacts);
    if (errors.billing_address) tabErrors.push(errors.billing_address);
    if (errors.shipping_address) tabErrors.push(errors.shipping_address);
    if (errors.billing_address_code) tabErrors.push(errors.billing_address_code);
    if (errors.shipping_address_code) tabErrors.push(errors.shipping_address_code);
    
    return tabErrors;
  };
  
  const documentsTabErrors = getDocumentsTabErrors();
  
  return (
    <div
      className={`fixed inset-0 z-50 flex justify-center transition-all duration-300 ease-in-out
        ${open ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
    >
      <style>
        {`
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .custom-scrollbar::-webkit-scrollbar {
            width: 8px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
          .address-table, .contact-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 1rem;
          }
          .address-table th, .address-table td, 
          .contact-table th, .contact-table td {
            padding: 0.5rem;
            border: 1px solid #e2e8f0;
            text-align: left;
          }
          .address-table th, .contact-table th {
            background-color: #f1f5f9;
            font-weight: 600;
            color: #64748b;
          }
          .address-table input, .contact-table input {
            width: 100%;
            border: none;
            padding: 0.25rem;
            background-color: transparent;
          }
          .address-table input:focus, .contact-table input:focus {
            outline: 1px solid #6a89a7;
            background-color: #f8fafc;
          }
          .address-error, .contact-error {
            color: #ef4444;
            font-size: 0.875rem;
            margin-top: 0.25rem;
          }
          .error-summary {
            background-color: #fef2f2;
            border-left: 4px solid #ef4444;
            padding: 1rem;
            margin-bottom: 1rem;
            border-radius: 0.375rem;
          }
          .error-summary-title {
            display: flex;
            align-items: center;
            font-weight: 600;
            color: #b91c1c;
            margin-bottom: 0.5rem;
          }
          .error-list {
            list-style-type: disc;
            padding-left: 1.5rem;
            color: #b91c1c;
          }
          .error-list li {
            margin-bottom: 0.25rem;
          }
        `}
      </style>
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
     <div 
        className={`bg-white shadow-2xl flex flex-col
          transition-transform transform-gpu duration-300 ease-in-out
          ${open ? 'translate-x-0' : 'translate-x-full'}
          ${isMaximized ? 'w-full h-full max-w-none m-0 rounded-none' : 'w-full max-w-6xl h-full rounded-none'}`}
      >
        <div className="flex-shrink-0 p-8 pb-6">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-[#384959]">{isEdit ? 'Edit Customer' : 'Create New Customer'}</h2>
            <div className="flex gap-2">
              <button 
                className="text-[#A0AEC0] hover:text-[#384959] transition-colors p-1" 
                onClick={toggleMaximize}
                title={isMaximized ? "Minimize" : "Maximize"}
              >
                {isMaximized ? <MinimizeIcon size={24} /> : <MaximizeIcon size={24} />}
              </button>
              <button 
                className="text-[#A0AEC0] hover:text-[#384959] transition-colors p-1" 
                onClick={onClose}
                title="Close"
              >
                <CloseIcon size={24} />
              </button>
            </div>
          </div>
        </div>
        
        {/* User validation warning */}
        {open && !isUserValid && (
          <div className="mx-8 mb-4 bg-red-50 border-l-4 border-red-500 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">
                  {authError || 'User information not available. Please refresh the page and log in again.'}
                </p>
              </div>
            </div>
          </div>
        )}
        
        <div className="flex-grow overflow-y-auto custom-scrollbar px-8">
          <form onSubmit={handleSubmit} className="space-y-6 pb-6" encType="multipart/form-data" id="customer-form">
            {/* Customer Information Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <div className='space-y-4'>
                <h3 className="text-lg font-semibold text-[#384959] mb-4">Customer Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Customer Code</label>
                    <input 
                      name="customer_code" 
                      value={isLoadingCode ? 'Loading...' : fields.customer_code} 
                      readOnly 
                      className="w-full border rounded-lg px-3 py-2 bg-[#F1F5F9] text-[#64748b] border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]" 
                    />
                  </div>
                  <div className='flex flex-col gap-2 '>
                    <label className="block text-sm font-medium text-[#64748b] ">Name *</label>
                    <input 
                      name="customer_name" 
                      autoComplete="off"
                      value={fields.customer_name} 
                      onChange={handleChange} 
                      className={`w-full border rounded-lg px-3 py-2 ${errors.customer_name ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase`} 
                    />
                    {errors.customer_name && <span className="text-xs text-red-500">{errors.customer_name}</span>}
                  </div>
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Customer Type</label>
                     <SearchableDropdown
    options={customerTypes}
    value={fields.customer_type}
    onChange={(value) => handleChange({ target: { name: 'customer_type', value } })}
    getOptionLabel={(type) => type.customer_type}
    getOptionValue={(type) => type.customer_type}
    placeholder="Select Customer Type"
    className="uppercase"
  />
                  </div>
                   <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Country *</label>
                    <input name="country" autoComplete="off" value={fields.country} onChange={handleChange} className={`w-full border rounded-lg px-3 py-2 ${errors.country ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase`} />
                    {errors.country && <span className="text-xs text-red-500">{errors.country}</span>}
                  </div>

                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Branch *</label>
                     <SearchableDropdown
    options={branches}
    value={fields.BranchCode}
    onChange={(value) => handleChange({ target: { name: 'BranchCode', value } })}
    getOptionLabel={(branch) => `${branch.BranchCode} - ${branch.BranchName}`}
    getOptionValue={(branch) => branch.BranchCode}
    getOptionSecondaryLabel={(branch) => branch.BranchName}
    placeholder={loadingBranches ? 'Loading branches...' : 'Select Branch'}
    error={errors.BranchCode}
    disabled={loadingBranches}
    className="uppercase"
  />
                    {errors.BranchCode && <span className="text-xs text-red-500">{errors.BranchCode}</span>}
                  </div>
                  
                  
                  {/* Department Selection Field - Only shown if ShowOnHeader is 1 */}
                  {showDepartmentField && (
                    <div className='flex flex-col gap-2'>
                      <label className="block text-sm font-medium text-[#64748b]">Department *</label>
                      <SearchableDropdown
      options={departments}
      value={fields.department_id}
      onChange={(value) => handleChange({ target: { name: 'department_id', value } })}
      getOptionLabel={(dept) => `${dept.DepartmentCode} - ${dept.DepartmentName}`}
      getOptionValue={(dept) => dept.DepartmentID.toString()}
      getOptionSecondaryLabel={(dept) => dept.DepartmentName}
      placeholder={loadingDepartments ? 'Loading departments...' : 'Select Department'}
      error={errors.department_id}
      disabled={loadingDepartments}
      className="uppercase"
    />
                      {errors.department_id && <span className="text-xs text-red-500">{errors.department_id}</span>}
                    </div>
                  )}
                 
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Status *</label>
                    <select name="status" value={fields.status} onChange={handleChange} className={`w-full border rounded-lg px-3 py-2 ${errors.status ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase`}>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    {errors.status && <span className="text-xs text-red-500">{errors.status}</span>}
                  </div>
                   {/* Add Branch Selection Field */}
                  
                  
                </div>
              </div>
            </div>
            
            {/* Contact Information Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <div className='space-y-6'>
                <h3 className="text-lg font-semibold text-[#384959] mb-4">Contact Information</h3>
                
                {/* Contacts Section */}
                <div>
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-md font-medium text-[#384959]">Contacts</h4>
                    <button 
                      type="button"
                      onClick={addContact}
                      className="flex items-center gap-1 px-3 py-1 bg-[#6A89A7] text-white text-sm rounded-lg hover:bg-[#88BDF2] transition-colors"
                    >
                      <PlusIcon size={14} /> Add Contact
                    </button>
                  </div>
                  
                  {errors.contacts && (
                    <div className="contact-error mb-2">{errors.contacts}</div>
                  )}
                  
                  <div className="overflow-x-auto">
                    <table className="contact-table">
                      <thead>
                        <tr>
                          <th>Contact Code *</th>
                          <th>First Name *</th>
                          <th>Last Name</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contacts.map((contact, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                value={contact.contact_code}
                                onChange={(e) => handleContactChange(index, 'contact_code', e.target.value)}
                                placeholder="Contact Code"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={contact.first_name}
                                onChange={(e) => handleContactChange(index, 'first_name', e.target.value)}
                                placeholder="First Name"
                                style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={contact.last_name}
                                onChange={(e) => handleContactChange(index, 'last_name', e.target.value)}
                                placeholder="Last Name"
                                style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="email"
                                value={contact.email}
                                onChange={(e) => handleContactChange(index, 'email', e.target.value)}
                                placeholder="Email"
                                style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={contact.phone_number}
                                onChange={(e) => handleContactChange(index, 'phone_number', e.target.value)}
                                placeholder="Phone Number"
                              />
                            </td>
                            <td>
                              {contacts.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => removeContact(index)}
                                  className="p-1 text-red-500 hover:text-red-700 transition-colors"
                                >
                                  <TrashIcon />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Address Information Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <div className='space-y-6'>
                <h3 className="text-lg font-semibold text-[#384959] mb-4">Address Information</h3>
                
                {/* Billing Addresses Section */}
                <div>
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-md font-medium text-[#384959]">Billing Addresses</h4>
                    <button 
                      type="button"
                      onClick={addBillingAddress}
                      className="flex items-center gap-1 px-3 py-1 bg-[#6A89A7] text-white text-sm rounded-lg hover:bg-[#88BDF2] transition-colors"
                    >
                      <PlusIcon size={14} /> Add Billing Address
                    </button>
                  </div>
                  
                  {errors.billing_address && (
                    <div className="address-error mb-2">{errors.billing_address}</div>
                  )}
                  
                  {errors.billing_address_code && (
                    <div className="address-error mb-2">{errors.billing_address_code}</div>
                  )}
                  
                  <div className="overflow-x-auto">
                    <table className="address-table">
                      <thead>
                        <tr>
                          <th>Address Code *</th>
                          <th>Address *</th>
                          <th>City *</th>
                          <th>State *</th>
                          <th>Zip Code *</th>
                          <th>Country *</th>
                          <th>GST No.</th>
                          <th>PAN No.</th>
                          <th>Contact Person</th>
                          <th>Contact No.</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billingAddresses.map((address, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                value={address.address_code}
                                onChange={(e) => handleBillingAddressChange(index, 'address_code', e.target.value)}
                                placeholder="Address Code"
                                style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.address_line1}
                                onChange={(e) => handleBillingAddressChange(index, 'address_line1', e.target.value)}
                                placeholder="Address"
                                style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.city}
                                onChange={(e) => handleBillingAddressChange(index, 'city', e.target.value)}
                                placeholder="City"
                                style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.state}
                                onChange={(e) => handleBillingAddressChange(index, 'state', e.target.value)}
                                placeholder="State"
                                style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.zip_code}
                                onChange={(e) => handleBillingAddressChange(index, 'zip_code', e.target.value)}
                                placeholder="Zip Code" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.country}
                                onChange={(e) => handleBillingAddressChange(index, 'country', e.target.value)}
                                placeholder="Country" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.gst_number}
                                onChange={(e) => handleBillingAddressChange(index, 'gst_number', e.target.value)}
                                placeholder="GST No." style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.pan_number}
                                onChange={(e) => handleBillingAddressChange(index, 'pan_number', e.target.value)}
                                placeholder="PAN No." style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.contact_person_name}
                                onChange={(e) => handleBillingAddressChange(index, 'contact_person_name', e.target.value)}
                                placeholder="Contact Person" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.contact_person_number}
                                onChange={(e) => handleBillingAddressChange(index, 'contact_person_number', e.target.value)}
                                placeholder="Contact No."
                              />
                            </td>
                            <td>
                              {billingAddresses.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => removeBillingAddress(index)}
                                  className="p-1 text-red-500 hover:text-red-700 transition-colors"
                                >
                                  <TrashIcon />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                
                {/* Shipping Addresses Section */}
                <div>
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-md font-medium text-[#384959]">Shipping Addresses</h4>
                    <button 
                      type="button"
                      onClick={addShippingAddress}
                      className="flex items-center gap-1 px-3 py-1 bg-[#6A89A7] text-white text-sm rounded-lg hover:bg-[#88BDF2] transition-colors"
                    >
                      <PlusIcon size={14} /> Add Shipping Address
                    </button>
                  </div>
                  
                  {errors.shipping_address && (
                    <div className="address-error mb-2">{errors.shipping_address}</div>
                  )}
                  
                  {errors.shipping_address_code && (
                    <div className="address-error mb-2">{errors.shipping_address_code}</div>
                  )}
                  
                  <div className="overflow-x-auto">
                    <table className="address-table">
                      <thead>
                        <tr>
                          <th>Address Code *</th>
                          <th>Address *</th>
                          <th>City *</th>
                          <th>State *</th>
                          <th>Zip Code *</th>
                          <th>Country *</th>
                          <th>GST No.</th>
                          <th>PAN No.</th>
                          <th>Contact Person</th>
                          <th>Contact No.</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {shippingAddresses.map((address, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                value={address.address_code}
                                onChange={(e) => handleShippingAddressChange(index, 'address_code', e.target.value)}
                                placeholder="Address Code" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.address_line1}
                                onChange={(e) => handleShippingAddressChange(index, 'address_line1', e.target.value)}
                                placeholder="Address" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.city}
                                onChange={(e) => handleShippingAddressChange(index, 'city', e.target.value)}
                                placeholder="City" style={{ textTransform: "uppercase" }}
                              /> 
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.state}
                                onChange={(e) => handleShippingAddressChange(index, 'state', e.target.value)}
                                placeholder="State" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.zip_code}
                                onChange={(e) => handleShippingAddressChange(index, 'zip_code', e.target.value)}
                                placeholder="Zip Code" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.country}
                                onChange={(e) => handleShippingAddressChange(index, 'country', e.target.value)}
                                placeholder="Country" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.gst_number}
                                onChange={(e) => handleShippingAddressChange(index, 'gst_number', e.target.value)}
                                placeholder="GST No." style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.pan_number}
                                onChange={(e) => handleShippingAddressChange(index, 'pan_number', e.target.value)}
                                placeholder="PAN No." style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.contact_person_name}
                                onChange={(e) => handleShippingAddressChange(index, 'contact_person_name', e.target.value)}
                                placeholder="Contact Person" style={{ textTransform: "uppercase" }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={address.contact_person_number}
                                onChange={(e) => handleShippingAddressChange(index, 'contact_person_number', e.target.value)}
                                placeholder="Contact No."
                              />
                            </td>
                            <td>
                              {shippingAddresses.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => removeShippingAddress(index)}
                                  className="p-1 text-red-500 hover:text-red-700 transition-colors"
                                >
                                  <TrashIcon />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Bank Information Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <div className='space-y-4'>
                <h3 className="text-lg font-semibold text-[#384959] mb-4">Bank Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Account No.</label>
                    <input name="account_number" autoComplete="off" value={fields.account_number} onChange={handleChange} className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase" />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Account Name</label>
                    <input name="account_name" autoComplete="off" value={fields.account_name} onChange={handleChange} className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase" />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">IFSC Code</label>
                    <input name="ifsc_code" autoComplete="off" value={fields.ifsc_code} onChange={handleChange} className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase" />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Bank Name</label>
                    <input name="bank_name" autoComplete="off" value={fields.bank_name} onChange={handleChange} className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase" />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Bank Branch</label>
                    <input name="bank_branch" autoComplete="off" value={fields.bank_branch} onChange={handleChange} className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase" />
                  </div>
                </div>
              </div>
            </div>
            
            {/* Documents Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <div className='space-y-4'>
                <h3 className="text-lg font-semibold text-[#384959] mb-4">Documents</h3>
                
                {/* Error Summary */}
                {submissionAttempted && documentsTabErrors.length > 0 && (
                  <div className="error-summary">
                    <div className="error-summary-title">
                      <ExclamationIcon className="mr-2" />
                      Please complete the following required fields:
                    </div>
                    <ul className="error-list">
                      {documentsTabErrors.map((error, index) => (
                        <li key={index}>{error}</li>
                      ))}
                    </ul>
                  </div>
                )}
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {['logo', 'gst_certificate', 'company_reg_certificate', 'nda_contract_file'].map(fieldName => (
                    <div key={fieldName} className='flex flex-col gap-2'>
                      <label className="block text-sm font-medium text-[#64748b]">{
                        {
                          logo: 'Company Logo',
                          gst_certificate: 'GST Certificate',
                          company_reg_certificate: 'Company Registration',
                          nda_contract_file: 'NDA Contract'
                        }[fieldName]
                      }</label>
                      <div className="flex items-center gap-2">
                        <input
                          type="file"
                          accept={fieldName === 'logo' ? 'image/*' : '.pdf,.doc,.docx'}
                          onChange={(e) => handleFileChange(e, fieldName)}
                          className="hidden"
                          id={`${fieldName}-upload`}
                          ref={
                            fieldName === 'logo' ? logoInputRef :
                            fieldName === 'gst_certificate' ? gstInputRef :
                            fieldName === 'company_reg_certificate' ? companyRegInputRef :
                            ndaInputRef
                          }
                        />
                        <label
                          htmlFor={`${fieldName}-upload`}
                          className="flex items-center gap-2 px-4 py-2 bg-[#6A89A7] text-white rounded-lg cursor-pointer hover:bg-[#88BDF2] shadow transition-colors"
                        >
                          <UploadIcon /> Upload
                        </label>
                        {filePreviews[fieldName] && (
                          <div className="flex items-center gap-2">
                            {getFilePreviewIcon(filePreviews[fieldName])}
                            <button
                              type="button"
                              onClick={() => handleFileRemove(fieldName,
                                fieldName === 'logo' ? logoInputRef :
                                fieldName === 'gst_certificate' ? gstInputRef :
                                fieldName === 'company_reg_certificate' ? companyRegInputRef :
                                ndaInputRef
                              )}
                              className="p-1 text-red-500 hover:text-red-700 transition-colors"
                            >
                              <TrashIcon />
                            </button>
                          </div>
                        )}
                        {isEdit && initialData?.[fieldName] && !isFile(fields[fieldName]) && !filePreviews[fieldName] && (
                          <div className="text-sm text-[#64748b]">
                            {typeof initialData[fieldName] === 'string' ? 
                              initialData[fieldName].split('/').pop() : 
                              'Existing file'}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </form>
        </div>
        
        <div className="flex-shrink-0 p-8 pt-0">
          <div className="flex justify-end gap-3">
            <button 
              type="button" 
              className="px-6 py-3 rounded-lg text-[#64748b] font-semibold transition-all duration-300 ease-in-out hover:bg-[#F1F5F9]" 
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="submit"
              form="customer-form"
              className="px-6 py-3 rounded-lg text-white font-semibold shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 bg-[#6A89A7] hover:bg-[#88BDF2] disabled:opacity-50 disabled:cursor-not-allowed" 
              disabled={formLoading || isSubmitting || isLoadingCode || !isUserValid}
              onClick={handleSubmit}
            >
              {formLoading || isSubmitting ? 'Saving...' : (isEdit ? 'Update Customer' : 'Create Customer')}
            </button>
          </div>
        </div>
      </div>
      <ErrorPopup
        show={errorPopup.show}
        messages={errorPopup.messages}
        onClose={() => setErrorPopup({ show: false, messages: [] })}
      />
    </div>
  );
};
export default CustomerFormModal;